module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-hail-fill-3e231523.svg";